import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import VendorManagerServices from "../../../services/API/VendorManager";
import AdminTable from "../../common/AdminTable/AdminTable";
import Pagination from "react-js-pagination";
import { useEffect } from "react";

const ExecutiveWorkloadStatistic = () => {
  const limit = 10;
  const [page, setPage] = useState(1);
  const [dataToShow, setDataToShow] = useState([]);

  const {
    data: executiveWorkload,
    isLoading,
    isFetching,
    refetch,
  } = useQuery(
    ["/api/alliance/dashboard/vendor_workload_list", { limit, page: 1 }], //
    VendorManagerServices.executiveWorkloadList,
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    if (executiveWorkload?.data.length) {
      const mutation = executiveWorkload?.data
        ? [...executiveWorkload.data]
        : [];

      const data = mutation?.splice(page * limit - limit, limit);

      setDataToShow(data);
    }
  }, [executiveWorkload, page]);

  const tableRows = [
    {
      title: "S. No.",
      value: (column, index) => limit * (page - 1) + index + 1,
      thProps: { width: "40px" },
    },
    {
      title: "Name",
      value: (column) => column?.name,
      thProps: { width: "240px" },
    },
    {
      title: "Assigned",
      value: (column) => (
        <Link
          to="/vendor/overall-license-requests"
          state={{ executiveName: column?.name, executiveId: column?.id }}
        >
          {column?.TotalAssigned}
        </Link>
      ),
      thProps: { width: "60px" },
    },
    {
      title: "Inprogress",
      value: (column) => (
        <Link
          to="/vendor/overall-license-requests"
          state={{
            executiveName: column?.name,
            executiveId: column?.id,
            card: {
              title: "Requests Inprogress",
              cardStatus: "in_progress",
            },
          }}
        >
          {column?.Inprogress}
        </Link>
      ),
      thProps: { width: "60px" },
    },
    {
      title: "Not Started",
      value: (column) => (
        <Link
          to="/vendor/overall-license-requests"
          state={{
            executiveName: column?.name,
            executiveId: column?.id,
            card: {
              title: "Requests Not Started",
              cardStatus: "not_started",
            },
          }}
        >
          {column?.not_started}
        </Link>
      ),
      thProps: { width: "60px" },
    },
    {
      title: "Completed",
      value: (column) => (
        <Link
          to="/vendor/overall-license-requests"
          state={{
            executiveName: column?.name,
            executiveId: column?.id,
            card: {
              title: "Requests Completed",
              cardStatus: "",
            },
          }}
        >
          {column?.Completed || 0}
        </Link>
      ),
      thProps: { width: "60px" },
    },
    {
      title: "TAT Score",
      value: (column) => column?.tat_score + "%",
      thProps: { width: "60px" },
    },
  ];
  return (
    <div>
      <div className="card card-sm card-shadow mb-3">
        <div className="card-body">
          <h4>Executive Workload Statistics</h4>
          <div
            className="table-responsive"
            style={{ height: "auto", overflowY: "scroll" }}
          >
            <AdminTable
              columns={tableRows}
              data={dataToShow}
              isDataLoading={false}
            />
          </div>
          {executiveWorkload?.data?.length > limit && (
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={executiveWorkload?.data?.length}
              pageRangeDisplayed={5}
              onChange={(number) => setPage(number)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ExecutiveWorkloadStatistic;
